
import React from 'react';
import { Header } from '../../components/feature/Header';
import { HeroSection } from '../../components/feature/HeroSection';
import { TrustIndicators } from '../../components/feature/TrustIndicators';
import { ProcessSection } from '../../components/feature/ProcessSection';
import { PropertyTypesSection } from '../../components/feature/PropertyTypesSection';
import { TestimonialsSection } from '../../components/feature/TestimonialsSection';
import { MarketCoverageSection } from '../../components/feature/MarketCoverageSection';
import { ComparisonSection } from '../../components/feature/ComparisonSection';
import { FAQSection } from '../../components/feature/FAQSection';
import { CTASection } from '../../components/feature/CTASection';
import { Footer } from '../../components/feature/Footer';

export default function HomePage() {
  return (
    <div className="font-sans">
      <Header />
      
      <main>
        <HeroSection />
        <TrustIndicators />
        <ProcessSection />
        <PropertyTypesSection />
        <TestimonialsSection />
        <MarketCoverageSection />
        <ComparisonSection />
        <FAQSection />
        <CTASection />
      </main>
      
      <Footer />
    </div>
  );
}
